export default __webpack_public_path__ + "static/media/dollar-idea.c0af2a7c.svg";